import React, {useState, useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
    Grid,
    Typography,
    TextField,
} from '@material-ui/core';
import DetailSelect from "views/Widgets/FichaPaciente/detailSelect";
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import {red, green, indigo} from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import api from "utils/API";
import {setmessageGeneral } from "actions/getGlobalAction";

// Tarea "SolicitudExamenes": única tarea de gescaec (permiso
// ResponderSolicitudesExtras) para el flujo de exámenes — los otros 3 flujos
// con documentos obligatorios ya tenían su propia tarea de gescaec (
// SolicitudInsumos, AutorizacionPersonalExtra, TrasladoAutorizacion,
// TerapiaAntibiotico) y ahí id_gescaec_autoriza se setea al aceptar esa tarea
// existente, sin pasar por este modal. Se genera en paralelo a la tarea del
// coordinador (ver Solicitud_Paciente.generar_tarea_gescaec_examenes), sin
// garantía de orden entre las dos vías. Al aprobar, la solicitud queda
// facturable de forma derivada (sin generar ninguna tarea nueva); al
// rechazar, se dispara la notificación al solicitante ya existente.
// "Solicitar documento" no resuelve la aprobación, solo genera la tarea
// puntual al coordinador que ya aprobó (ver
// Solicitud_Paciente.crear_tarea_documento_faltante) — si el coordinador
// todavía no aprobó, no tiene efecto.
const listTipoDocumentoFaltante = [
    {value: "OrdenInsumosMedicamentos", label: "Orden médica (insumos y medicamentos)"},
    {value: "OrdenPersonalClinico", label: "Orden médica (personal clínico)"},
    {value: "OrdenExamenes", label: "Orden de examen"},
    {value: "OrdenTraslado", label: "Orden de traslado"},
    {value: "FichaClinica", label: "Ficha clínica"},
    {value: "FichaClinicaDiasUso", label: "Ficha clínica con días de uso"},
    {value: "EvidenciaDano", label: "Evidencia del daño"},
    {value: "CotizacionExamenExterna", label: "Cotización examen empresa externa"},
];

export default function ModalAprobacionGescaec({
    open,
    closeModal,
    rowInfo,
    setinitialCharge,
}) {
    const dispatch = useDispatch();
    const [listFile, setlistFile] = useState([]);
    const [sending, setsending] = useState(false);
    const [openModalReject, setopenModalReject] = useState(false);
    const [openModalSolicitarDocumento, setopenModalSolicitarDocumento] = useState(false);
    const [motivoRechazo, setmotivoRechazo] = useState("");
    const [tipoDocumentoFaltante, settipoDocumentoFaltante] = useState({});

    const dictTypeRequest = useSelector(state => state.currentList.DICCIONARIO_TIPO_SOLICITUD_PACIENTE);
    const dictTypeFile = useSelector(state => state.currentList.DICCIONARIO_TIPO_ARCHIVO_PACIENTE);

    const idSolicitud = rowInfo.id_solicitud_paciente?.id;

    useEffect(() => {
        api.get(`api/documentospaciente/?tarea_paciente=${rowInfo.id}`).then(response => {
            setlistFile(response.data)
        });
    }, []);

    const handleDownloadFile = (link) => {
        window.open(link)
    }

    const resolver = (body, mensajeExito) => {
        if (sending) {
            return;
        }
        setsending(true);
        api.patch(`api/clinica/solicitudes/extras/paciente/${idSolicitud}/gescaec/`, body).then(() => {
            setmessageGeneral(dispatch, mensajeExito, "success", "¡Éxito!");
            setinitialCharge(true)
            closeModal()
        }).catch(() => {
            setmessageGeneral(dispatch, "No se pudo procesar la acción", "error", "Error");
            setsending(false);
        })
    }

    const handleAprobar = () => resolver({estado: "Aprobar"}, "Solicitud aprobada por gestión clínica");
    const handleRechazar = () => resolver({estado: "Rechazar"}, "Solicitud rechazada por gestión clínica");
    const handleSolicitarDocumento = () => resolver(
        {estado: "SolicitarDocumento", tipo_documento_faltante: tipoDocumentoFaltante.value},
        "Se generó la tarea de documento faltante para el coordinador"
    );

    const patientData = rowInfo.id_ficha?.id_paciente
    const patientName = patientData ? `${patientData.nombre} ${patientData.apellido_paterno} ${patientData.apellido_materno}` : ""
    const typeRequest = dictTypeRequest[rowInfo?.id_solicitud_paciente?.Tipo_Solicitud_Paciente]

    let nameUserRequest = ""
    let coordinatorName = ""
    const userRequest = rowInfo?.id_solicitud_paciente?.id_persona_solicitante
    const coordinadorStatus = rowInfo?.id_solicitud_paciente?.id_coordinador_autoriza
    if (userRequest){
        nameUserRequest = `${userRequest["first_name"]} ${userRequest["last_name"]}`
    }
    if (coordinadorStatus){
        coordinatorName = `${coordinadorStatus["first_name"]} ${coordinadorStatus["last_name"]}`
    }

    const _content_ = <div>
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            <Typography variant="body1">
                <b>Paciente:</b> {patientName} — <b>Solicitud:</b> {typeRequest?.label} (#{idSolicitud})
            </Typography>
        </Grid>
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            <Typography variant="body2">
                <b>Solicitante:</b> {nameUserRequest} — <b>Coordinador que aprobó:</b> {coordinatorName}
            </Typography>
        </Grid>

        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            {listFile.length === 0 && <Typography variant="body2">Sin documentos adjuntos</Typography>}
            {listFile.map((row) => (
                <Grid item xs={12} key={row.id}>
                    <Button
                        variant="outlined"
                        color="primary"
                        title={`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                        style={{margin: "5px", width: "100%", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "none"}}
                        onClick={() => handleDownloadFile(row.archivo)}
                    >
                        {`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                    </Button>
                </Grid>
            ))}
        </Grid>
    </div>

    const _actions_ = <>
        <Button
            disabled={sending}
            variant="contained"
            style={{backgroundColor: green[500]}}
            className="text-white"
            onClick={handleAprobar}
        >
            Aprobar
        </Button>
        <Button
            disabled={sending}
            variant="contained"
            style={{backgroundColor: red[500]}}
            className="text-white"
            onClick={() => setopenModalReject(true)}
        >
            Rechazar
        </Button>
        <Button
            disabled={sending}
            variant="contained"
            color="primary"
            onClick={() => setopenModalSolicitarDocumento(true)}
        >
            Solicitar documento
        </Button>
        <Button
            variant="contained"
            style={{backgroundColor: indigo[500]}}
            className="text-white"
            onClick={closeModal}
        >
            Cerrar
        </Button>
    </>

    const _contentReject_ = <Grid item container xs={12}>
        <TextField
            label={"Motivo rechazo"}
            multiline
            rows={6}
            value={motivoRechazo}
            variant="outlined"
            onChange={(event) => setmotivoRechazo(event.target.value)}
            style={{width: "100%"}}
        />
    </Grid>

    const _actionsReject_ = <>
        <Button
            disabled={sending}
            variant="contained"
            style={{backgroundColor: red[500]}}
            className="text-white"
            onClick={handleRechazar}
        >
            Rechazar
        </Button>
        <Button variant="contained" style={{backgroundColor: indigo[500]}} className="text-white" onClick={() => setopenModalReject(false)}>
            Cerrar
        </Button>
    </>

    const _contentSolicitarDocumento_ = <Grid item container xs={12}>
        <DetailSelect
            label="Tipo de documento"
            value={tipoDocumentoFaltante}
            onchange={(value) => settipoDocumentoFaltante(value)}
            list={listTipoDocumentoFaltante}
        />
    </Grid>

    const _actionsSolicitarDocumento_ = <>
        <Button
            disabled={sending || !tipoDocumentoFaltante.value}
            variant="contained"
            color="primary"
            onClick={handleSolicitarDocumento}
        >
            Solicitar
        </Button>
        <Button variant="contained" style={{backgroundColor: indigo[500]}} className="text-white" onClick={() => setopenModalSolicitarDocumento(false)}>
            Cerrar
        </Button>
    </>

    return (
        <>
        <ModalDialog
            open={open}
            onClose={closeModal}
            title={`Aprobación Gestión Clínica - Exámenes`}
            _content_={_content_}
            _actions_ = {_actions_}
            maxWidth="md"
        />
        {openModalReject &&
        <ModalDialog
            open={openModalReject}
            onClose={() => setopenModalReject(false)}
            title={`Rechazar solicitud`}
            _content_={_contentReject_}
            _actions_ = {_actionsReject_}
            maxWidth="sm"
        />
        }
        {openModalSolicitarDocumento &&
        <ModalDialog
            open={openModalSolicitarDocumento}
            onClose={() => setopenModalSolicitarDocumento(false)}
            title={`Solicitar documento faltante`}
            _content_={_contentSolicitarDocumento_}
            _actions_ = {_actionsSolicitarDocumento_}
            maxWidth="sm"
        />
        }
        </>
    );
}
